<template>
    <div class="gmf-achievement-image" :class="classes">
        <object v-if="useObjectHack" type="image/svg+xml" :data="achievement.imageUrl"></object>
        <img v-else :src="achievement.imageUrl" />
        <!-- @TODO lock icon from merchant config -->
        <ProgressBar v-if="isSticker && isLocked && progress > 0 && showProgress" :value="progress" />
        <Icon v-if="isSticker && isLocked" icon="https://cdn.gamifiera.com/static/global/M2ydabGj8swa5Gf7.svg" />
    </div>
</template>

<style>
.gmf-achievement-image {
    position: relative;
    aspect-ratio: 1;
}

.gmf-achievement-image img,
.gmf-achievement-image object {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.gmf-achievement-image-sticker.gmf-achievement-image-unlocked img {
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, .5));
}

.gmf-achievement-image-sticker.gmf-achievement-image-locked img {
    filter: brightness(0) invert(100%) sepia(0%) saturate(6266%) hue-rotate(172deg) brightness(110%) contrast(95%);
}

.gmf-achievement-image-sticker .gmf-icon {
    position: absolute;
    inset: 30%;
    height: 40%;
    width: 40%;
}

.gmf-achievement-image .gmf-progress-bar {
    position: absolute;
    left: 4px;
    right: 4px;
    width: auto;
    height: 16px;
    bottom: 10%;
}

.gmf-achievement-image .gmf-progress-bar-fill {
    height: 100%;
}
</style>

<script>
import Icon from '@/components/Icon.vue';
import state from '@/state';
import isSafari from '@/utils/isSafari';
import ProgressBar from '@/components/ProgressBar.vue';

export default {
    name: 'AchievementImage',
    props: {
        achievement: {
            Type: Object,
            required: true,
        },
        showProgress: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Icon,
        ProgressBar,
    },
    computed: {
        progress() {
            let totalProgress = 0;
            for (const goal of this.achievement.goals) {
                const p = Math.min(goal.progress / goal.targetProgressValue, 1);
                totalProgress += p / this.achievement.goals.length;
            }
            return totalProgress;
        },
        isLocked() {
            return !(this.achievement.achievedAt > 0);
        },
        classes() {
            return {
                'gmf-achievement-image-sticker': this.isSticker,
                'gmf-achievement-image-unlocked': !this.isLocked,
                'gmf-achievement-image-locked': this.isLocked,
            };
        },
        isSticker() {
            return state.merchantConfig.achievements.imageType === 'sticker';
        },
        useObjectHack() {
            if (this.isSticker) {
                return false;
            }
            return this.achievement.staticImageUrl && isSafari;
        },
    },
};
</script>